import Time from '../../../../bower_components/teknisavuecomponents/assets/utils/Time';
import { Periodo } from '../../../../bower_components/teknisavuecomponents/assets/interfaces/interfaces';

export default class PeriodoController {
  
  public static getPeriodoAtual(dataAtual: string | Date, periodos: Periodo[]) {
    if (typeof dataAtual === 'string') {
      dataAtual = Time.dateStringToDate(dataAtual);
    }
    let periodoAtual: any = false;
    for (let periodo of periodos) {
      const periodoFim = Time.dateStringToDate(periodo.DTFINALAPURACAO);
      const periodoIni = Time.dateStringToDate(periodo.DTINICIALAPURACAO);

      if (dataAtual <= periodoFim && dataAtual >= periodoIni) {
        periodoAtual = periodo;
      }
    }
    return periodoAtual;
  }
}